import { ComponentProps } from 'react';
import { MenuItem } from 'react-aria-components';

import { Typography } from '../typography/typography';
import { twMerge } from 'tailwind-merge';
import { mapper } from '@maia/icons';
import { profileMenuItemStyles, ProfileMenuItemStyles } from './variants';

export type ProfileMenuItemProps = {
  text: string;
  icon?: string;
  className?: string;
} & Omit<ComponentProps<typeof MenuItem>, 'className' | 'children'> &
  ProfileMenuItemStyles;

export function ProfileMenuItem(props: ProfileMenuItemProps) {
  const { text, icon, className, intent = 'default', ...rest } = props;

  return (
    <MenuItem
      className={twMerge(profileMenuItemStyles({ intent }), className)}
      {...rest}
    >
      {icon && <div>{mapper(icon)}</div>}
      <Typography variant="body-xs" weight="medium">
        {text}
      </Typography>
    </MenuItem>
  );
}
